"use strict";

var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TimeoutError_1 = require("./TimeoutError");

var utils_1 = require("./utils");

var PendingOperation =
/*#__PURE__*/
function () {
  function PendingOperation(timeoutMillis) {
    var _this = this;

    _classCallCheck(this, PendingOperation);

    this.timeoutMillis = timeoutMillis;
    this.deferred = utils_1.defer();
    this.possibleTimeoutCause = null;
    this.promise = timeout(this.deferred.promise, timeoutMillis).catch(function (err) {
      if (err instanceof TimeoutError_1.TimeoutError) {
        if (_this.possibleTimeoutCause) {
          err = new TimeoutError_1.TimeoutError(_this.possibleTimeoutCause.message);
        } else {
          err = new TimeoutError_1.TimeoutError('operation timed out for an unknown reason');
        }
      }

      return Promise.reject(err);
    });
  }

  _createClass(PendingOperation, [{
    key: "abort",
    value: function abort() {
      this.reject(new Error('aborted'));
    }
  }, {
    key: "reject",
    value: function reject(err) {
      this.deferred.reject(err);
    }
  }, {
    key: "resolve",
    value: function resolve(value) {
      this.deferred.resolve(value);
    }
  }]);

  return PendingOperation;
}();

exports.PendingOperation = PendingOperation;

function timeout(promise, time) {
  return new Promise(function (resolve, reject) {
    var timeoutHandle = setTimeout(function () {
      return reject(new TimeoutError_1.TimeoutError());
    }, time);
    promise.then(function (result) {
      clearTimeout(timeoutHandle);
      resolve(result);
    }).catch(function (err) {
      clearTimeout(timeoutHandle);
      reject(err);
    });
  });
}